export default __webpack_public_path__ + "static/media/Silk-Serif-SemiBold.8aaf998b.otf";